import { Input, Label } from '@iwoca/orion';
import { Trans, useLingui } from '@lingui/react/macro';
import { useFormContext } from 'react-hook-form';

import styles from './WebsiteScreen.module.css';
import { websiteSchema } from './WebsiteScreen.schema';
import { TMobileSignupForm } from '../../form/form';
import { useStageFieldTracking } from '../../form/MobileSignupFieldTracking';
import { useScreenValidation } from '../../form/validation/useScreenValidation';
import { StepLayout } from '../../StepLayout/StepLayout';

// Company website. Optional — an empty value passes validation and advances,
// mirroring the desktop CompanyDetailsDE field. Reads/writes the shared mobile
// signup form store; persisted with the rest of the company stage on turnover.
export const WebsiteScreen = () => {
  const { t } = useLingui();
  const {
    register,
    formState: { errors },
  } = useFormContext<TMobileSignupForm>();
  const { validateAndContinue } = useScreenValidation(websiteSchema);
  const { fieldProps } = useStageFieldTracking();

  return (
    <StepLayout
      stageTitle={t`Business details`}
      heading={t`Your company website`}
      onContinue={validateAndContinue}
      fieldProps={fieldProps}
    >
      <Label htmlFor="website" className={styles.label}>
        <Trans>Website</Trans>
        <span className={styles.optional}>
          {' '}
          (<Trans>optional</Trans>)
        </span>
      </Label>
      <Input
        {...register('website')}
        id="website"
        type="text"
        inputMode="url"
        placeholder={t`www.example.com`}
        error={errors.website?.message}
      />
    </StepLayout>
  );
};
